// WARNING: this file is AUTOGENERATED, only main.ts and index.ts are editable
// rerun yarn generate:enums to update

import { ITranslationTable } from '../EnumClass';

export const name: ITranslationTable = {
  /* eslint-disable max-len */
  content: (t, data?, options?) => t('enum.staff-position.content.name', data, options),
  corporateSupport: (t, data?, options?) => t('enum.staff-position.corporate-support.name', data, options),
  customerSupport: (t, data?, options?) => t('enum.staff-position.customer-support.name', data, options),
  developer: (t, data?, options?) => t('enum.staff-position.developer.name', data, options),
  dictionaryContent: (t, data?, options?) => t('enum.staff-position.dictionary-content.name', data, options),
  marketing: (t, data?, options?) => t('enum.staff-position.marketing.name', data, options),
  seniorContent: (t, data?, options?) => t('enum.staff-position.senior-content.name', data, options),
  seniorCorporateSupport: (t, data?, options?) => t('enum.staff-position.senior-corporate-support.name', data, options),
  seniorCustomerSupport: (t, data?, options?) => t('enum.staff-position.senior-customer-support.name', data, options),
  seniorDeveloper: (t, data?, options?) => t('enum.staff-position.senior-developer.name', data, options),
  seniorTranslation: (t, data?, options?) => t('enum.staff-position.senior-translation.name', data, options),
  seniorTutorRecruitment: (t, data?, options?) => t('enum.staff-position.senior-tutor-recruitment.name', data, options),
  seniorTutorSupport: (t, data?, options?) => t('enum.staff-position.senior-tutor-support.name', data, options),
  tester: (t, data?, options?) => t('enum.staff-position.tester.name', data, options),
  translation: (t, data?, options?) => t('enum.staff-position.translation.name', data, options),
  tutorPayroll: (t, data?, options?) => t('enum.staff-position.tutor-payroll.name', data, options),
  tutorRecruitment: (t, data?, options?) => t('enum.staff-position.tutor-recruitment.name', data, options),
  tutorSupport: (t, data?, options?) => t('enum.staff-position.tutor-support.name', data, options),
  /* eslint-enable max-len */
};
